import { request } from "../utils";
import { SHOP_API } from "./constants";

export const getShop = () => {
  return request.get(SHOP_API);
};
